module.exports = __webpack_public_path__ + "media/images/sales/early/eyecatch-early-01-bd96a61cedd598b658d0341e7da2ce70.svg";